import { t } from "i18next";
import { useNavigate } from "react-router-dom";

import Exit from "@/assets/icons/exit.svg?react";
import { Achievements } from "@/components/Achievements";
import { Header } from "@/components/Header";
import { useStore } from "@/hooks/store";
import { useNetworkDependentActions } from "@/hooks/useNetworkDependentActions";
import { APP_ROUTES } from "@/routes/constants";
import { ApiVersion, apiVersion } from "@/utils";

import DashboardNetwork from "./DashboardNetwork";
import styles from "./styles";

export const Dashboard: React.FC = () => {
  const navigate = useNavigate();
  const { networks, totalScore } = useStore((store) => ({
    totalScore: store.user.totalScore,
    networks: Object.values(store.user.networksData),
  }));

  const { disconnect } = useNetworkDependentActions();

  return (
    <styles.Container>
      <Header />
      <styles.Scores>
        <styles.Title>{t("Dashboard.YourTrustScores")}</styles.Title>
        <styles.Networks>
          {Boolean(totalScore) && (
            <styles.TotalScore>
              <p>{t("Home.TotalTrustScore")}</p>
              <p>{totalScore}</p>
            </styles.TotalScore>
          )}
          {networks.map(({ network, score, nft }) => (
            <DashboardNetwork network={network} score={score} nft={nft} />
          ))}
        </styles.Networks>
      </styles.Scores>
      <Achievements />
      <styles.EmptyBody>
        {disconnect && apiVersion === ApiVersion.v2 ? (
          <styles.Button
            onClick={() => {
              disconnect();
              navigate(APP_ROUTES.HOME);
            }}
          >
            <Exit />
            {t("Actions.Disconnect")}
          </styles.Button>
        ) : null}
      </styles.EmptyBody>
    </styles.Container>
  );
};
